import { Trans } from "@lingui/react/macro";
import {
  buttonVariants,
  cn,
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarProvider,
} from "@rakazo/ui-web";
import { UserRound } from "lucide-react";
import { Link } from "react-router-dom";
import { WindowChrome } from "./WindowChrome";

/** A signed-out desktop entry must not mount the workspace or its authenticated queries. */
export function DesktopGuestShell({ signInPath }: { signInPath: string }) {
  return (
    <SidebarProvider
      className="h-full min-h-0"
      data-testid="desktop-guest-shell"
      data-rakazo-surface="desktop-guest"
    >
      <Sidebar collapsible="none" className="max-w-[60vw] border-e border-sidebar-border">
        <SidebarHeader className="app-drag px-5 py-[18px]">
          <WindowChrome />
        </SidebarHeader>
        <SidebarContent />
        <SidebarFooter className="px-2.5 py-3">
          <Link
            to={signInPath}
            className={cn(buttonVariants({ variant: "ghost" }), "app-no-drag w-full justify-start")}
          >
            <UserRound aria-hidden="true" />
            <Trans>Sign in</Trans>
          </Link>
        </SidebarFooter>
      </Sidebar>
      <main className="min-w-0 flex-1 bg-background">
        <div className="app-drag h-12" aria-hidden="true" />
      </main>
    </SidebarProvider>
  );
}
